import { Routes, RouterModule }  from '@angular/router';

import { FOCviewRequestAddComponent} from './foc-create/foc-create.component';
import { FOCviewRequestReturnComponent } from './foc-return/foc-return.component';
import { FOCviewRequestConfirmComponent } from './foc-confirm/foc-confirm.component';
import { FOCviewRequestsComponent} from './foc-viewrequests.component';


export const FOCRequestsRoutes: Routes = [
    {
        path: '',
        component: FOCviewRequestsComponent,
        children: [
            { path: '', redirectTo: '/app/foc_dashboard', pathMatch: 'full' },
            { path: 'create/:id', component: FOCviewRequestAddComponent },
            { path: 'return/:id', component: FOCviewRequestReturnComponent },
            { path: 'confirm/:id', component: FOCviewRequestConfirmComponent }
        ]
    }
];

export const FOCRequestsRoutingModule = RouterModule.forChild(FOCRequestsRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/FOCviewRequest/foc-viewrequests-routing.module.ts